import { ReactNode } from 'react';
import { cn } from '@/shared/utils/utils';

export interface DashboardGridProps {
  children: ReactNode;
  className?: string;
  columns?: number;
  gap?: number;
}

export function DashboardGrid({
  children,
  className,
  gap = 6, // Tailwind gap-6 (1.5rem / 24px)
}: DashboardGridProps) {
  // We use CSS Grid with 12 columns for fine-grained layout control
  return (
    <div
      className={cn('grid w-full auto-rows-min grid-cols-1 md:grid-cols-12', className)}
      style={{ gap: `${gap * 0.25}rem` }}
    >
      {children}
    </div>
  );
}

export interface GridItemProps {
  children: ReactNode;
  w?: number; // span columns (1-12)
  h?: number; // min height rows
  className?: string;
}

export function GridItem({ children, w = 12, h = 1, className }: GridItemProps) {
  return (
    <div
      className={cn('w-full', className)}
      style={{
        gridColumn: `span ${w} / span ${w}`,
        minHeight: `${h * 100}px`, // Baseline height multiplier for future responsive grids
      }}
    >
      {children}
    </div>
  );
}
